import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";
import {Button} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import UniversalModalOverride from "components/UniversalModalOverride";
import WarningAlert from "components/Elements/DispositionPendingWarningAlert";
import {
	dismissUnprinted4473Reminder,
	shouldShowUnprinted4473Reminder
} from "utils/unprinted4473Reminder";


// const breadcrumbsStatic = [
// 	{
// 		name: 'Dashboard',
// 		url: '/',
// 		icon: 'dashboard',
// 	},
// ];

class Dashboard extends Framework.Components.View {
	static defaultProps = {
		locations: [],
	}

	constructor(props) {
		super(props);
		this.state.pawn_ticket = '';
		this.state.code = null;
		this.state.showUnprinted4473Reminder = shouldShowUnprinted4473Reminder();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevProps.scannedCode !== this.props.scannedCode && this.props.scannedCode) {
			this.setState({
				code: this.props.scannedCode
			}, () => {
				this.toggle('modalProduct')();
			});
		}
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	handleSendClick = () => {
		localStorage.setItem('pawn_search', this.state.pawn_ticket);
		this.props.history.push(`/acquisitions/pawns#${this.state.pawn_ticket}`);
	}

	handleDismiss4473Reminder = () => {
		dismissUnprinted4473Reminder();
		this.setState({showUnprinted4473Reminder: false});
	}

	render() {
		const activeLocations = this.props.locations.filter(
			/** @type {Locations_Object} location **/
			location => !location.archived
		);
		return (
			<div className="container-fluid">
				{this.props.rootState.hasPawnModule &&
					<Framework.Components.PageBar history={this.props.history}>
						<div style={{height: "38px"}}>
							<div className="d-flex" style={{width: '300px', maxWidth: '300px'}}>
								<div className="flex-grow-1" style={{height: '38px', paddingTop: '3px', backgroundColor: 'white'}}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pawn_ticket"
										label="Loan # / Pawn Ticket Search"
										value={this.state.pawn_ticket}
										onChange={this.handleDataChange}
									/>
								</div>
								<div style={{height: '38px', paddingTop: '2px', marginLeft: '1px'}} className="mr-auto">
									<Button
										className={'btn-block green-meadow'}
										onClick={this.handleSendClick}
									>Search
									</Button>
								</div>
							</div>
						</div>
					</Framework.Components.PageBar>
				}
				{this.state.showUnprinted4473Reminder &&
					<WarningAlert
						warningName={'Print your 4473s'}
						warningMessage={'FFL Boss Cloud is not enabled for this account, and 4473s have been completed without clicking Print Form at least 3 times. Make sure you print and retain your 4473s after completion.'}
						noIgnore={'Dismiss'}
						onAlertDismiss={this.handleDismiss4473Reminder}
					/>}
				{activeLocations.length === 0 &&
					<WarningAlert
						warningName={'Your Server Rental Has Been Cancelled'}
						warningMessage={'Your server rental has been cancelled and your data is scheduled for deletion. Thank you for using our software.'}
						hideButton={true}
					/>}
				{
					activeLocations.map((location) =>
						<Objects.Dashboard
							key={location.pkey}
							parent={location.pkey}
							parent_binary_id={location.binary_id}
							location={location}
							history={this.props.history}
							locations={this.props.locations}
							states={this.props.states}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
						/>
					)
				}

				<UniversalModalOverride
					name={"Product"}
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					id={this.state.code ? this.state.code.barcode : null}
					objectProps={{
						params: {
							id: this.state.code ? (this.state.code.prefix + '-' + this.state.code.barcode) : null
						}
					}}
					object={Objects.ProductUpdate}
					toggle={this.state['modalProduct']}
					reportClose={this.reportClose('modalProduct')}
					size={"xl"}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(Dashboard);

